import React from "react"

const WaitTagSeleniumAtom = () => {
  return <span id="selenium-wait" />
}

export default WaitTagSeleniumAtom
